import React, { useRef, useState } from 'react';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade'; // web.cjs is required for IE 11 support
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import {isMobile} from 'react-device-detect';
import TextField from '@material-ui/core/TextField';
import ButtonBase from '../Buttons/ButtonBase';
import Tooltip from '@material-ui/core/Tooltip';
import { setShareTrophie } from '../../store/actions/UserAction';
import { connect } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'Column',
    width: 530,
    //minHeight: 272,
    borderRadius: 4,
    padding: '16px 16px 16px 24px',
    boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
    backgroundColor: 'white',
    '&:focus': {
      outline: 'none',
    },
  },
  root: {
    width: 200,
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  infoWrapper: {
    //padding: '32px 38px 0',
    //display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
  },
  name: {
    fontSize: 22,
    color: '#10587f',
    marginBottom: 16,
    marginTop: 8,
  },
  shareButton: {
    width: 136,
  },
  socialIcons: {
    maxWidth: 376,
    padding: '26px 0 46px',
    display: 'flex',
    justifyContent: 'space-between',
    //gridAutoFlow: 'column',
    //gridGap: 24,
    margin: '0 auto',
  },
  description: {
    maxWidth: 438,
    margin: '0 0 40px 0',
  },
  textField: {
    width: 296,
    marginRight: 15,
  },
}));

const ModalShareArticle = ({ link, open, handleClose, handleSubmit }) => {
  const classes = useStyles();

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div className={classes.infoWrapper}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h2 id="spring-modal-title" className={classes.name}>
                  Compartir
                </h2>
                <div onClick={handleClose} style={{ cursor: 'pointer' }}>
                  <img src="/img/icons/close.svg" alt="close" />
                </div>
              </div>

              <div className={classes.socialIcons}>
                <div>
                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${link}`}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    onClick={() => {
                      handleSubmit()
                      handleClose()
                    }
                  }
                  >
                    <img
                      src="/img/socialMediaIcons/facebook.svg"
                      alt="facebook"
                    />
                  </a>
                </div>
                <div>
                  <a
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${link}`}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    onClick={() => {
                      handleSubmit()
                      handleClose()
                    }
                  }
                  >
                    <img
                      src="/img/socialMediaIcons/linke-in.svg"
                      alt="linked-in"
                    />
                  </a>
                </div>

                <div>
                  <a
                    className="twitter-share-button"
                    href={`https://twitter.com/intent/tweet?&url=${link}`}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    onClick={() => {
                      handleSubmit()
                      handleClose()
                    }
                  }
                  >
                    <img
                      src="/img/socialMediaIcons/twitter.svg"
                      alt="twitter"
                    />
                  </a>
                </div>
                <div>
                  <a
                    href={`https://api.whatsapp.com/send?text=${link}`}
                    data-action="share/whatsapp/share"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    onClick={() => {
                      handleSubmit()
                      handleClose()
                    }
                  }
                  >
                    <img
                      src="/img/socialMediaIcons/whatsapp.svg"
                      alt="whatsapp"
                    />
                  </a>
                </div>
                {isMobile && <div>
                  <a 
                    href={`fb-messenger://share/?link=${link}`} 
                    onClick={() => {
                      handleSubmit()
                      handleClose()
                    }}
                    rel="noopener noreferrer nofollow"
                  >
                    <img src="/img/socialMediaIcons/messenger.svg" alt="messenger" />
                  </a>
                </div>}
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default ModalShareArticle;
